import { useCallback, useContext, useMemo, useState } from 'react';
import type { ChatContextItem } from '@trinity/chat';
import { ChatContextType } from '@trinity/chat';
import { ActiveChatSessionContext } from '@trinity/chat-components/components/Chat/context';
import { HeaderContextContext } from './context';

type Props = {
  children: React.ReactNode;
};

export const ContextSelectorContainer = (props: Props) => {
  const [pendingContextType, setPendingContextType] = useState<ChatContextType>();
  const [pendingEverythingSearch, setPendingEverythingSearch] = useState(false);
  const [pendingContext, setPendingContext] = useState<ChatContextItem>();
  const session = useContext(ActiveChatSessionContext);

  const displayContextType = useMemo(() => {
    if (pendingContextType) {
      return pendingContextType;
    }
    return session.context.type;
  }, [session.context.type, pendingContextType]);

  const handleCancelPendingSearch = useCallback(() => {
    setPendingContextType(undefined);
    setPendingEverythingSearch(false);
    setPendingContext(undefined);
  }, [setPendingContextType, setPendingEverythingSearch, setPendingContext]);

  const handleSetContextType = useCallback(
    (type: ChatContextType) => {
      if (type !== ChatContextType.Agent) {
        // Only agents have subject autocomplete settings
        setPendingContext(undefined);
      }
      setPendingContextType(type);
    },
    [setPendingContextType, setPendingContext]
  );

  const ctxValue = {
    cancelPendingSearch: handleCancelPendingSearch,
    displayContextType,
    pendingContextType,
    setPendingContextType: handleSetContextType,
    pendingEverythingSearch,
    setPendingEverythingSearch,
    pendingContext,
    setPendingContext,
  };

  return <HeaderContextContext.Provider value={ctxValue}>{props.children}</HeaderContextContext.Provider>;
};
